import React from 'react';
import { Typography, TextField, FormControl, InputLabel, Select, MenuItem, Grid, Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useStyles } from '../../pages/projects/list/styles/projectFormModalStyles';

// ----------------------------------------------------------------------

const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'prefer-not-to-say', label: 'Prefer not to say' },
];

export default function PersonalInfoSection({ isEditing, values, errors, touched, getFieldProps, setFieldValue }) {
  const classes = useStyles();
  const renderField = (fieldName, label, type = 'text') => {
    if (isEditing) {
      if (fieldName === 'gender') {
        return (
          <FormControl fullWidth error={touched.gender && Boolean(errors.gender)} variant="outlined">
            <InputLabel>Gender</InputLabel>
            <Select {...getFieldProps('gender')} label="Gender">
              {GENDER_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {touched.gender && errors.gender && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                {errors.gender}
              </Typography>
            )}
          </FormControl>
        );
      }

      if (fieldName === 'dateOfBirth') {
        return (
          <Box><DatePicker
            label="Date of Birth"
            value={values.dateOfBirth}
            onChange={(newValue) => setFieldValue('dateOfBirth', newValue)}
            defaultCalendarMonth={dayjs().subtract(18, 'year')}
            maxDate={dayjs()}
            inputFormat="DD MMM YYYY"
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="outlined"
                error={touched.dateOfBirth && Boolean(errors.dateOfBirth)}
                helperText={touched.dateOfBirth && errors.dateOfBirth}
              />
            )}
          /></Box>
        );
      }
      if(fieldName==="emergencyContactPersonName"){
        if(isEditing){
          return (
        <TextField
          fullWidth
          label="Emergency Contact Person Name"
          {...getFieldProps(fieldName)}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          helperText={touched[fieldName] && errors[fieldName]}
          variant="outlined"
        />
      );
        }
      }

      return (
        <TextField
          fullWidth
          label={label}
          {...getFieldProps(fieldName)}
          error={touched[fieldName] && Boolean(errors[fieldName])}
          helperText={touched[fieldName] && errors[fieldName]}
          variant="outlined"
        />
      );
    }

    // View mode
    const getDisplayValue = () => {
      if (fieldName === 'gender') {
        return values.gender ? GENDER_OPTIONS.find((opt) => opt.value === values.gender)?.label : 'Not provided';
      }
      if (fieldName === 'dateOfBirth') {
        return values.dateOfBirth ? dayjs(values.dateOfBirth).format('DD MMM YYYY') : 'Not provided';
      }
      return values[fieldName] || 'Not provided';
    };

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ minWidth: '140px' }}>
          {label}:
        </Typography>
        <Typography variant="body1">{getDisplayValue()}</Typography>
      </Box>
    );
  };

  return (
    <>
      <Typography variant="h6" className={classes.memberUpdateModelTitle} sx={{ mb: 2 }}>
        Personal Information
      </Typography>

      <Grid container spacing={isEditing ? 3 : 1}>
        <Grid item xs={12}>
          {renderField('fullName', 'Full Name')}
        </Grid>

        <Grid item xs={12}>
          {renderField('gender', 'Gender')}
        </Grid>

        <Grid item xs={12}>
          {renderField('phoneNo', 'Phone Number')}
        </Grid>

         <Grid item xs={12}>
          {renderField('emergencyContactPersonName','Contact Name')}
        </Grid>

        <Grid item xs={12}>
          {renderField('emergencyContact', 'Emergency Contact')}
        </Grid>

        <Grid item xs={12}>
          {renderField('dateOfBirth', 'Date of Birth')}
        </Grid>
      </Grid>
    </>
  );
}
